import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CountdownUtil from '../../utils/countdown-util';
import Playlist from '../../models/playlist';

class Countdown extends Component {

    constructor(props) {

        super(props);

        this.state = {
            countdown: this.props.countdown,
        };

        // Utiliy to manage counting down from the specified value
        this.countdownInstance = CountdownUtil({
            seconds: this.props.countdown,
            signal: this.onUpdateCountdown.bind(this),
            complete: this.onCountdownComplete.bind(this),
        });

    }

    componentWillUnmount() {

        this.countdownInstance.cancel();

    }

    onUpdateCountdown(seconds) {

        this.setState({ countdown: seconds });

    }

    onCountdownComplete() {

        const nextItem = this.props.playlist.getNextItem();
        this.props.onCountdownComplete(nextItem);

    }

    render() {

        const { countdown } = this.state;

        return (
            <div className="countdown">
                <p>Next Video in {countdown}</p>
            </div>
        );

    }

}

Countdown.propTypes = {
    /** The the amount of time to count down */
    countdown: PropTypes.number,
    /** The list of media items to playback */
    playlist: PropTypes.instanceOf(Playlist),
    /** Funciton to handle when the countdown is complete. It will pass the next item in the playlist */
    onCountdownComplete: PropTypes.func.isRequired,
};

Countdown.defaultProps = {
    countdown: 7,
    playlist: new Playlist([]),
};

export default Countdown;
